import classNames from "classnames";
import {CyClass} from "../../../../common/cy-classes";
import React from "react";
import {MobileLangSwitcherMenuItemSelectedLangBox} from "./boxes/mobile-lang-switcher-menu-item-selected-lang.box";
import {MobileLangSwitcherContainerBox} from "./boxes/mobile-lang-switcher-container.box";
import {MobileLanguageMenuItemBox} from "../boxes/mobile-language-menu-item.box";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";

interface MobileLangSwitcherMenuItemComponentProps extends ComponentServicesPick<'sideMenu'> {

}

const ComponentBody: React.FC<MobileLangSwitcherMenuItemComponentProps> = observer((props) => {
    const services = useServices();
    return (
        <MobileLangSwitcherContainerBox className="cy-menu-item" onClick={() => props.sideMenu.openMobileLanguageSwitcher()}>
            <MobileLanguageMenuItemBox className={CyClass('cy-lang-switch-label')}>
                {services.translation.translate("LANGUAGES")}
            </MobileLanguageMenuItemBox>
            <MobileLangSwitcherMenuItemSelectedLangBox className={classNames(CyClass('cy-lang-switch-current-lang'))}>
                {services.language.currentLanguage}
            </MobileLangSwitcherMenuItemSelectedLangBox>
        </MobileLangSwitcherContainerBox>
    );
})

export const MobileLangSwitcherMenuItemComponent = withServices(ComponentBody, ['sideMenu']);